// Age in years from DOM year, using mid-year (July 1) convention
export const computeAgeYears = (domYear, referenceDate = new Date()) => {
  const dom = new Date(domYear, 6, 1); // July 1
  return (referenceDate - dom) / (365.25 * 24 * 60 * 60 * 1000);
};

// Round to nearest step (5 or 10)
export const roundToNearest = (value, step) => Math.round(value / step) * step;

// Degressive depreciation factor: (1 - usage/horizon)^power, floored
export const degressiveFactor = (usage, horizon, power, floor = 0) => {
  if (usage >= horizon) return floor;
  return Math.max(floor, Math.pow(1 - usage / horizon, power));
};

// S-curve factor (blended power curve with sigmoid transition)
// Blends power_early and power_late via sigmoid, then raises (1-t) to the blended power.
// factor = (1 - t) ^ (power_early * (1-w) + power_late * w)
export const sCurveFactor = (usage, horizon, midpoint, powerEarly, powerLate, steepness) => {
  if (usage >= horizon) return 0;
  if (usage <= 0) return 1;
  const t = usage / horizon;
  const midT = midpoint / horizon;
  const w = 1 / (1 + Math.exp(-steepness * (t - midT)));
  const p = powerEarly * (1 - w) + powerLate * w;
  return Math.pow(1 - t, p);
};

// Exponential decay: floor + (1 - floor) * e^(-lambda * age)
export const exponentialDecay = (age, lambda, floor) => {
  return floor + (1 - floor) * Math.exp(-lambda * age);
};

// Linear decay: max(floor, 1 - age/endOfLife)
export const linearDecay = (age, endOfLife, floor) => {
  return Math.max(floor, 1 - age / endOfLife);
};

// Estimate jumps from age using exponential saturation: cap * (1 - e^(-age/tau))
export const estimateJumpsFromAge = (age, cap, tau) => {
  return cap * (1 - Math.exp(-age / tau));
};
